import { Button } from 'antd'
import clsx from 'clsx'
import type { Dispatch, SetStateAction } from 'react'
import { useMemo } from 'react'

import { useLocalStorage } from '@/context/localstorage-context'

export default function StepOne({
  canRegist,
  setStep,
}: {
  canRegist: boolean
  setStep: Dispatch<SetStateAction<number>>
}) {
  const { theme } = useLocalStorage()
  const isDark = useMemo(() => theme === 'dark', [theme])
  const btnCln = clsx('w-full flex justify-between mt-[20px]', {
    'btn1-light': !isDark,
    'btn1-dark': isDark,
  })
  return (
    <div>
      <div className="border-b-1 border-b-light-555 dark:border-b-dark-666">
        <p className="text-3xl text-light-111 mb-[0] dark:text-dark-111">
          Node Overview & Requirements
        </p>
        <p className="text-xl text-light-444 my-[10px]">
          Before becoming a Wanchain Bridge Validator (also known as a Storeman
          Node), ensure you meet the following hardware and staking
          requirements.
        </p>
      </div>
      <div className="flex mt-[10px] dark:text-white">
        <div className="flex-1 flex flex-col">
          <span className="text-[14px] font-inter font-semibold text-light-0 dark:text-white">
            Minimum Hardware Requirements
          </span>
          <div className="grid grid-cols-2 gap-[1px] grid-auto-rows:100px text-[13px] mt-[5px] dark:bg-dark-333">
            <div className="bg-light-888 px-6 py-2 text-light-999 rounded-tl-[10px] dark:bg-dark-333 dark:text-dark-0">
              Item
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 rounded-tr-[10px] dark:bg-dark-333 dark:text-dark-0">
              Requirement (Minimum)
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 dark:bg-dark-333 dark:text-dark-0">
              CPU
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 dark:bg-dark-333 font-medium">
              2 cores
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 dark:bg-dark-333 dark:text-dark-0">
              RAM
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 dark:bg-dark-333 font-medium">
              8 GB
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 dark:bg-dark-333 dark:text-dark-0">
              Disk Space
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 dark:bg-dark-333 font-medium">
              80 GB
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 rounded-bl-[10px] dark:bg-dark-333 dark:text-dark-0">
              Operating System
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 rounded-br-[10px] dark:bg-dark-333 font-medium">
              Ubuntu 22.04
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-[15px] dark:text-white">
        <div className="flex-1 flex flex-col ">
          <span className="text-[14px] font-inter font-semibold text-light-0 dark:text-white">
            Staking Requirements
          </span>
          <div className="text-light-0 text-[13px] dark:text-dark-0 pl-[10px]">
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Minimum Stake: <span className="font-bold">10,000 WAN</span>
              </li>
              <li>
                Staking Period: <span className="font-bold">~30 days</span>{' '}
                (from the 9th of each month to the 9th of the following month)
              </li>
              <li>
                Node Selection: Only the
                <span className="font-bold pl-[5px]">top 25 nodes</span> by
                total stake will be selected as active validators. Unselected
                nodes may withdraw their funds
                <span className="font-bold pl-[4px]">
                  after the 10th of each month
                </span>
                .
              </li>
              <li>
                Node Exit: If you initiate an exit during the month, you can
                withdraw the staked WAN
                <span className="font-bold pl-[4px]">
                  after the 10th of the following month
                </span>
                .
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="flex mt-[5px] dark:text-white">
        <div className="flex-1 flex flex-col">
          <span className="text-[14px] font-inter font-semibold text-light-0 dark:text-white">
            Registration Window
          </span>
          <span className="text-[13px] dark:text-dark-0">
            Monthly Open Window: 1st 04:00 a.m. UTC – 5th 04:00 a.m. UTC
          </span>
        </div>
      </div>
      <div className={btnCln}>
        <Button
          disabled
          className="w-[49%] rounded-2xl h-[60px] text-[18px] dark:bg-dark-666"
        >
          Previous
        </Button>
        <Button
          disabled={!canRegist}
          className="w-[49%] rounded-2xl h-[60px] btn text-[18px]"
          onClick={() => setStep(11)}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
